/*
 * @Description:
 * @Author: CcSimple
 * @Github: https://github.com/CcSimple
 * @Date: 2023-02-09 10:40:26
 * @LastEditors: CcSimple
 * @LastEditTime: 2023-02-09 11:37:21
 */
import { hiprint } from "vue-plugin-hiprint";
export const provider1 = function () {
  var addElementTypes = function (context) {
    context.removePrintElementTypes("providerModule1");
    context.addPrintElementTypes("providerModule1", [
      new hiprint.PrintElementTypeGroup("常规", [
        // options.config,
        {
          tid: "providerModule1.header",
          title: "常规标题",
          data: "常规标题",
          type: "text",
          testConfig:'testConfig',
          options: {
            testConfigTwo:'testConfigTwo',
            testData: "常规标题",
            height: 20,
            fontSize: 16,
            fontWeight: "700",
            textAlign: "center",
            textContentVerticalAlign:"middle",
            hideTitle: true,
          },
        },
        {
          tid: "providerModule1.type",
          title: "常规内容",
          data: "常规内容",
          type: "text",
          options: {
            testData: "",
            height: 20,
            fontSize: 16,
            textAlign: "center",
            textContentVerticalAlign:"middle",
            hideTitle: true,
            field: "oneValue",
            fields: [
              { text: "字段1", field: "oneValue" },
              { text: "字段2", field: "twoValue" },
            ],
          },
        },
        {
          tid: "providerModule1.barcode",
          title: "条形码",
          data: "mh1234567890",
          type: "text",
          options: {
            field: "barcode",
            testData: "mh1234567890",
            height: 32,
            fontSize: 12,
            lineHeight: 18,
            textAlign: "left",
            textType: "barcode",
          },
        },
        {
          tid: "providerModule1.qrcode",
          title: "二维码",
          data: "mh1234567890",
          type: "text",
          options: {
            field: "qrcode",
            testData: "mh1234567890",
            height: 64,
            fontSize: 12,
            lineHeight: 18,
            textType: "qrcode",
          },
        },
        // { tid: "providerModule1.image", title: "Logo", data: "http://localhost:8080/static/img/mh-2.6ad1da49.png", type: "image" },
      ]),
      new hiprint.PrintElementTypeGroup("客户/定制化", [
        {
          tid: "providerModule1.khname",
          title: "客户名称",
          data: "xxxxxx",
          type: "text",
          options: {
            field: "name",
            testData: "xxxxxx",
            width:200,
            height: 20,
            fontSize: 16,
            fontWeight: "700",
            textAlign: "left",
            textContentVerticalAlign: "middle",
          },
        },
        {
          tid: "providerModule1.tel",
          title: "客户电话",
          data: "18888888888",
          type: "text",
          options: {
            field: "tel",
            testData: "18888888888",
            width:200,
            height: 20,
            fontSize: 16,
            fontWeight: "700",
            textAlign: "left",
            textContentVerticalAlign: "middle",
          },
        },
      ]),
    ]);
  };
  return {
    addElementTypes: addElementTypes,
  };
};
